import { OfferLockEventProperties } from '@jusbrasil-web/shared-apollo-client/types'
import { useUserSession } from '@jusbrasil-web/shared-user-session'
import { useDispatcher } from '@jusbrasil-web/shared-utils-events'
import { useCallback } from 'react'

import { BoxMetricEventName } from '../types'
import { boxEventProperties } from '../utils/events'

/**
 * Sends `Box.<eventName>` events directly to Argos, with the snake_case
 * properties expected by the `box_events` table in BigQuery.
 */
export const useSendBoxEvent = () => {
  const { sendMetrics, ref: elementRef } = useDispatcher<HTMLDivElement>()
  const session = useUserSession()

  const sendBoxEvent = useCallback(
    (eventName: BoxMetricEventName, eventProperties?: OfferLockEventProperties | null) => {
      const { device, deviceName, browser, browserVersion, os } = boxEventProperties()
      const properties = { ...(eventProperties ?? ({} as OfferLockEventProperties)) }
      delete properties.__typename

      const pid = properties.pid ?? session?.pid

      sendMetrics(`Box.${eventName}`, pid ? String(pid) : null, {
        ...properties,
        pid,
        device,
        device_name: deviceName,
        browser,
        browser_version: browserVersion,
        os,
      })
    },
    [sendMetrics, session]
  )

  return { sendBoxEvent, elementRef }
}
